var _rect, _rect2, _path, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividualfeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 127,
    viewBox: "0 0 32 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#A814DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2236 14.6436H15.4893C15.9814 14.6436 16.3887 14.5586 16.7109 14.3887C17.0391 14.2188 17.2822 13.9844 17.4404 13.6855C17.5986 13.3867 17.6777 13.0439 17.6777 12.6572C17.6777 12.2529 17.6045 11.9072 17.458 11.6201C17.3174 11.3271 17.1006 11.1016 16.8076 10.9434C16.5205 10.7852 16.1543 10.7061 15.709 10.7061C15.334 10.7061 14.9941 10.7822 14.6895 10.9346C14.3906 11.0811 14.1533 11.292 13.9775 11.5674C13.8018 11.8369 13.7139 12.1592 13.7139 12.5342H11.5869C11.5869 11.8545 11.7656 11.251 12.123 10.7236C12.4805 10.1963 12.9668 9.7832 13.582 9.48438C14.2031 9.17969 14.9004 9.02734 15.6738 9.02734C16.5 9.02734 17.2207 9.16504 17.8359 9.44043C18.457 9.70996 18.9404 10.1143 19.2861 10.6533C19.6318 11.1924 19.8047 11.8604 19.8047 12.6572C19.8047 13.0205 19.7197 13.3896 19.5498 13.7646C19.3799 14.1396 19.1279 14.4824 18.7939 14.793C18.46 15.0977 18.0439 15.3467 17.5459 15.54C17.0479 15.7275 16.4707 15.8213 15.8145 15.8213H14.2236V14.6436ZM14.2236 16.2959V15.1357H15.8145C16.5645 15.1357 17.2031 15.2236 17.7305 15.3994C18.2637 15.5752 18.6973 15.8184 19.0312 16.1289C19.3652 16.4336 19.6084 16.7822 19.7607 17.1748C19.9189 17.5674 19.998 17.9834 19.998 18.4229C19.998 19.0205 19.8896 19.5537 19.6729 20.0225C19.4619 20.4854 19.1602 20.8779 18.7676 21.2002C18.375 21.5225 17.915 21.7656 17.3877 21.9297C16.8662 22.0938 16.2979 22.1758 15.6826 22.1758C15.1318 22.1758 14.6045 22.0996 14.1006 21.9473C13.5967 21.7949 13.1455 21.5693 12.7471 21.2705C12.3486 20.9658 12.0322 20.5879 11.7979 20.1367C11.5693 19.6797 11.4551 19.1523 11.4551 18.5547H13.5732C13.5732 18.9355 13.6611 19.2725 13.8369 19.5654C14.0186 19.8525 14.2705 20.0781 14.5928 20.2422C14.9209 20.4062 15.2959 20.4883 15.7178 20.4883C16.1631 20.4883 16.5469 20.4092 16.8691 20.251C17.1914 20.0928 17.4375 19.8584 17.6074 19.5479C17.7832 19.2373 17.8711 18.8623 17.8711 18.4229C17.8711 17.9248 17.7744 17.5205 17.5811 17.21C17.3877 16.8994 17.1123 16.6709 16.7549 16.5244C16.3975 16.3721 15.9756 16.2959 15.4893 16.2959H14.2236Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    width: 4,
    height: 95,
    fill: "#A814DC",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualfeature3);
export default __webpack_public_path__ + "static/media/Individual.feature3.35648172401520646ebd87b68c82fa5e.svg";
export { ForwardRef as ReactComponent };